import React, { useEffect, useState } from "react";
import { allUsers, getUsersForSubsite, userTotalCount, getXlsUserReport, unregisteredCount } from '../../reducers/users';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { PersonFill, PersonFillExclamation } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import UserService from "../../services/user.service";
import Form from "react-bootstrap/Form";
import { Container, Row, Col } from "react-bootstrap";

const AdminUsersBulkEdit = () => {
    const users = useSelector(allUsers);
    const userStatus = useSelector(state => state.users.status);
    const dispatch = useDispatch();
    const [range, setRange] = useState([1, 10000]);
    const [reload, setReload] = useState(false);
    const [message, setMessage] = useState(null);
    const [selectedOption, setSelectedOption] = useState("active");
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (userStatus === 'idle') {
            dispatch(getUsersForSubsite([range, selectedOption, searchTerm]));
        }
    }, [userStatus, dispatch]);

    useEffect(() => {
        dispatch(getUsersForSubsite([range, selectedOption, searchTerm]));
    }, [range, reload, dispatch]);

    let content = "";

    if (userStatus === 'loading') {
        content = <Spinner text="Loading..." />
    } else if (userStatus === 'succeeded') {
        content = users.map((user, idx) => (
            <Row style={{ padding: 2, backgroundColor: idx % 2 == 0 ? "#FFFFFF" : "#CCCCCC" }}>
                <Col xs={1}>{user.registration_id || !user.active ? <PersonFillExclamation size={15} color="#990000" /> : <PersonFill size={15} color="#009900" />}</Col>
                <Col xs={4}>{user.username}</Col>
                <Col xs={4}>{user.lastname}, {user.firstname}</Col>
                <Col xs={1}>{user.subsiteBalance ? user.subsiteBalance?.balance : 0}</Col>
                <Col xs={1}><input id={`user_${user.id}`} type="text" style={{ width: 50 }} /></Col>
                <Col xs={1}><input id={`user_${user.id}-ch`} type="checkbox" style={{ width: 50 }} /></Col>
            </Row>
        ));
    } else if (userStatus === 'failed') {
        content = <div>error</div>
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let updates = [];
        for (var i = 0; i < users.length; i++) {
            let user = users[i];
            let newBalance = document.getElementById(`user_${users[i].id}`).value;
            if (newBalance && newBalance !== "") {
                updates.push({ id: users[i].id, newBalance: newBalance });
            }
        }
        UserService.updateUserBalances(updates).then(response => {
            if(response.errors && response.errors.length > 0) {
                var message = [];
                for(var i = 0; i < response.errors.length; i++) {
                    message.push(<li>User - ${response.errors[i].id} - ${response.errors[i].error}</li>);
                }
                setMessage(message);
            } else {
                setMessage(null);
            }
            dispatch(getUsersForSubsite([range, selectedOption, searchTerm]));
        });
    }

    return (
        <Container style={{ padding: 4 }}>
            <Row>
                <Col>
                    <h2>Users Bulk Edit</h2>
                </Col>
            </Row>
            <Row style={{ padding: 4 }}>
                <Col>
                    Fill in the text boxes to update all user's balances. A blank field will be ignored and will leave the user's balance unchanged.  To remove a balance, set the value to 0. Click the "Update All Users" button to save changes.
                </Col>
            </Row>
            {message && (
                <Row style={{ padding: 4 }}>
                    <Col>
                        {message && (
                            <>Errors:
                            <ul>
                            {message.map((msg) => (
                            <div>{msg}</div>
                            ))}
                            </ul>
                            </>
                        )}
                    </Col>
                </Row>
            )}
            <Row>
                <Col>
                    <Form onSubmit={handleSubmit}>
                        <Container style={{ fontSize: 12 }}>
                            <Row style={{ backgroundColor: "#333333", color: "#FFFFFF" }}>
                                <Col xs={1}>Status</Col>
                                <Col xs={4}>Username</Col>
                                <Col xs={4}>Name</Col>
                                <Col xs={1}>Old Balance</Col>
                                <Col xs={1}>New Balance</Col>
                                <Col xs={1}>Roll Balance</Col>
                            </Row>
                            {content}
                        </Container>
                        <br/>
                        <Button onClick={handleSubmit}>Update All Users</Button>
                        </Form>
                </Col>
            </Row>
            <Row>
                <Col>
                </Col>
            </Row>
        </Container>
    );
};
export default AdminUsersBulkEdit;

